import React, { useEffect, useState } from "react";
import { DropdownButton, Dropdown, Card } from "react-bootstrap";
import StoreImages from "./../../../assets/background_banners.webp";
import storelistCategory from "./../../../assets/storelistCategory.png";
import category_icon from "./../../../assets/category-icon.png";
import "./StorelistPage.css";
import { connect } from "react-redux";
import { currentLocationInfo } from "../../home/redux/actions";
import { storeCategories } from "../../home/redux/actions";
import store_default from "../../../assets/store_default.png";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import no_product from "../../../assets/no_product.svg";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import { LazyLoadImage } from "react-lazy-load-image-component";
import close_cross from "../../../assets/close_cross.svg";
import { postRequestcall } from "../../comman/util/postRequest";
import {
  ADD_BOOKMARK,
  SEARCH,
  STORE_SEARCH,
  UN_BOOKMARK,
} from "../../constants/apiurl";
import { getRequestcall } from "../../comman/util/getRequest";
import PaginationPage from "../../comman/components/PaginationPage";
import CategoryList from "../../comman/components/CategoryList";
import SearchProductPage from "../../comman/components/SearchProductPage";

const ImagePreviewLoader = ({item}) =>{
    return(
      <LazyLoadImage
        alt=""
        src={
          item.image_url === null
            ? store_default
            : item.image_url
        }
        onError={(event) => {
          event.target.src = store_default;
        }}
        className="store-img transition animi-images"
      />
    )
}

function StorelistPage(props) {
  
  const { t } = useTranslation();
  const [Categorydrawer, setCategorydrawer] = useState(false);
  const [storelist, setStorelist] = useState([]);
  const [searchshop, setSearchshop] = useState("");
  const [nopagination, setNopagination] = useState();
  const [links, setLinks] = useState([]);
  const [sortType, setSorttype] = useState("");
  const [sortinglatest, setSortinglatest] = useState("");
  const [sortingname, setSortingname] = useState("");
  const [mostVisited, setMostVisited] = useState("");
  var [paginationvalue, setPaginationvalue] = useState({
    total: 1,
    from: 0,
    to: 0,
    per_page:20
  });

  const navigate = useNavigate();
  const location = useLocation();
  const getId = useParams();
  
  // eslint-disable-next-line
  useEffect(() => {
    (async () => getStorelisting())();
    // eslint-disable-next-line
  }, [location?.state?.obj]);

  // eslint-disable-next-line
  useEffect(()=>{
    props?.fetchHeaderContent(t("pages.meta.store.title"),t("pages.meta.store.description"), "");
      // eslint-disable-next-line
  },[props?.language]);

  const getStorelisting = async () => {
    window.scrollTo({ top: 0, behavior: "smooth" }); // After selection of category from footer page to top
    let categorylistitem = "";
    if(typeof getId?.id === "undefined") {
      categorylistitem = "";
    }else{
      categorylistitem = getId?.id?.split(",");
     if(categorylistitem?.length > 0) {
      let getList =props?.categories?.map((item)=>{
        let selected = categorylistitem?.filter((value)=> value === item?.id);
        if(selected?.length > 0) {
            return {
               ...item,
               is_checked:true
            }
        }else{
          return {
            ...item,
            is_checked:false
         };
        }
       });
       props.storeCategories(getList);
     }else{
      categorylistitem = "";
     }
    }
    let refreshData = {
      lat: props.currentLocation.lat,
      lng: props.currentLocation.lng,
      page: 1,
      category: categorylistitem,
      search: searchshop,
      sort_by_desc: "",
      most_visited:"",
      sort_by_name: "",
      per_page:paginationvalue?.per_page
    };
    await getStorelist(refreshData);
  };

  const getStorelist = async (refreshData) => {
    let getResponse;
     if(refreshData?.lat && refreshData?.lng !== "") {
      if (!props.access_token) {
        let geturl =
          STORE_SEARCH +
          `?page=${refreshData?.page}&status=${""}&lat=${Number(
            refreshData?.lat
          )}&lng=${Number(refreshData?.lng)}&distance=${""}&category=${
            refreshData?.category
          }&rating=${""}&search=${refreshData?.search}&type=${
            props.storetype
          }&most_visited=${refreshData?.most_visited}&sort_by_desc=${refreshData?.sort_by_desc}&sort_by_name=${
            refreshData?.sort_by_name
          }&pagination=${refreshData?.per_page}`;
        getResponse = await postRequestcall(geturl, "", "");
      } else {
        let geturl =
          SEARCH +
          `?page=${refreshData.page}&status=${""}&lat=${Number(
            refreshData.lat
          )}&lng=${Number(refreshData.lng)}&distance=${""}&category=${
            refreshData.category
          }&most_visited=${refreshData?.most_visited}&rating=${""}&search=${refreshData.search}&type=${
            props.storetype
          }&sort_by_desc=${refreshData.sort_by_desc}&sort_by_name=${
            refreshData.sort_by_name
          }&pagination=${refreshData?.per_page}`;
        getResponse = await postRequestcall(geturl, props.access_token);
      }
      if (getResponse?.status === 200) {
        let storeList = await getResponse.json();
        if (storeList?.data?.storeData?.data?.length === 0) {
          setNopagination(true);
          setStorelist([]);
          setLinks([]);
          setPaginationvalue({
            total: 0,
            from: 0,
            to: 0,
            per_page:20
          });
        } else {
          setStorelist(storeList?.data?.storeData?.data);
          setLinks(storeList?.data?.storeData?.links);
          setPaginationvalue({
            total: storeList?.data?.storeData?.total,
            from: storeList?.data?.storeData?.from,
            to: storeList?.data?.storeData?.to,
            per_page: storeList?.data?.storeData?.per_page
          });
          setNopagination(false);
        }
      }
     }else{
      navigate("/")
     }
    
  };

  // Pagination
  const changeCurrentpage = async (page) => {
    let array = [];
    let categorylistitem = "";
    props.categories.forEach((item) => {
      if (item.is_checked === true) {
        array.push(item.id);
      }
    });
    categorylistitem = array.join(",");
    let refreshData = {
      lat: props.currentLocation.lat,
      lng: props.currentLocation.lng,
      page: page,
      category: categorylistitem,
      search: searchshop,
      sort_by_desc: sortinglatest,
      sort_by_name: sortingname,
      most_visited: mostVisited,
      per_page:paginationvalue?.per_page
    };
    getStorelist(refreshData);
  };

  const selectCategoryfromlist = async (item, index) => {
    let getId;
    if (item?.is_checked === false) {
      props.categories[index].is_checked = true;
    } else {
      props.categories[index].is_checked = false;
    }
    props.storeCategories(props.categories);
    let value = props.categories.filter((item) => item.is_checked === true);
    if (value.length > 0) {
      getId = value
        .map((item) => {
          return item.id;
        })
        .join(",");
    } else {
      getId = "";
    }
    let refreshData = {
      lat: props.currentLocation.lat,
      lng: props.currentLocation.lng,
      page: 1,
      category: getId,
      search: searchshop,
      sort_by_desc: sortinglatest,
      sort_by_name: sortingname,
      most_visited: mostVisited,
      per_page:paginationvalue?.per_page
    };
    if(getId !== "") {
      window.history.replaceState(null,"","/stores/"+getId);
    }else{
      window.history.replaceState(null,"","/stores");
    }
    getStorelist(refreshData);
  };

  const openStore = (storeId) => {
    navigate(`/detail/${storeId}`);
  };

  const getInputsearchvalue = (e) => {
    setSearchshop(e.target.value);
    getSearchedlist(e.target.value);
  };

  const searchInput = async (e) => {
    if (e.key === "Enter") {
      getSearchedlist(searchshop);
    }
  };

  const getSearchedlist = (searchValue) => {
    let getId;
    let value = props.categories.filter((item) => item.is_checked === true);
    if (value.length > 0) {
      getId = value
        .map((item) => {
          return item.id;
        })
        .join(",");
    } else {
      getId = "";
    }
    let refreshData = {
      lat: props.currentLocation.lat,
      lng: props.currentLocation.lng,
      page: 1,
      category: getId,
      search: searchValue,
      sort_by_desc: sortinglatest,
      sort_by_name: sortingname,
      most_visited: mostVisited,
      per_page:paginationvalue?.per_page
    };
    getStorelist(refreshData);
  };

  const addorremoveBookmark = async (e, id, bookmark, bookmark_id) => {
    e.stopPropagation();
    e.preventDefault();
    if (props.access_token) {
      let getResponse;
      if (bookmark === "no") {
        let payload = {
          type: "store",
          bookmark: id,
        };
        getResponse = await postRequestcall(ADD_BOOKMARK,props?.access_token,payload);
      } else {
        getResponse = await getRequestcall(UN_BOOKMARK + `/${bookmark_id}`,props.access_token);
      }
      if (getResponse?.status === 200) {
        let addbookmark = await getResponse.json();
        let updateStatus = [];
        storelist.forEach((item) => {
          if (item.id === id) {
            item.bookmark = bookmark === "no" ? "yes" : "no";
            item.bookmarkColor = bookmark === "no" ? "#ff2d00" : "#cdcdcd";
            item.bookmark_id = bookmark === "no" ? addbookmark?.data?.bid : "";
          }
          updateStatus.push(item);
        });
        setStorelist(updateStatus);
      }
    } else {
      toast.error(t("pages.Please login"));
    }
  };

  const clearCategories = () => {
    let value = [];
    props.categories.forEach((item) => {
      if (item.is_checked === true) {
        item.is_checked = false;
      }
      value.push(item);
    });
    props.storeCategories(value);
    let refreshData = {
      lat: props.currentLocation.lat,
      lng: props.currentLocation.lng,
      page: 1,
      category: "",
      search: searchshop,
      sort_by_desc: "",
      most_visited: "",
      sort_by_name: "",
      per_page:paginationvalue?.per_page
    };
    window.history.replaceState(null, '', "/stores");
    getStorelist(refreshData);
  };

  const sortingList = (e, type) => {
    e.preventDefault();
    let array = [];
    let categorylistitem = "";
    props.categories.forEach((item) => {
      if (item.is_checked === true) {
        array.push(item.id);
      }
    });
    categorylistitem = array.join(",");
    let sort_by_desc = "";
    let sort_by_name = "";
    let most_visited = "";
    if (type === "desc") {
      setSorttype("pages.stores.sort_latest");
      sort_by_desc = "desc";
      setSortinglatest(sort_by_desc);
      setMostVisited("");
      setSortingname("");
    } else if(type === "most") {
      setSorttype("pages.stores.Most Visited");
      most_visited = "yes";
      setSortinglatest("");
      setSortingname("");
      setMostVisited("yes");
    } else {
      setSorttype("pages.stores.Sort by name");
      sort_by_name = "asc";
      setSortinglatest("");
      setMostVisited("");
      setSortingname(sort_by_name);
    }
    let refreshData = {
      lat: props.currentLocation.lat,
      lng: props.currentLocation.lng,
      page: 1,
      category: categorylistitem,
      search: searchshop,
      sort_by_desc: sort_by_desc,
      sort_by_name: sort_by_name,
      most_visited: most_visited,
      per_page:paginationvalue?.per_page
    };
    getStorelist(refreshData);
  };

  return (
    <>
      <aside className="storelist">
        <div className="background-image">
          <LazyLoadImage alt="" src={StoreImages} className="banner-img" />
          <SearchProductPage
            id="searchform"
            onChange={getInputsearchvalue}
            value={searchshop}
            onKeyPress={searchInput}
            placeholder={t("pages.stores.search-place")}
          />
        </div>
        <div className="container">
          <div className="row">
            <div className={Categorydrawer ? "col-xl-3 show category_div" : "col-xl-3 category_div"}>
              <Card className="shadow">
                <Card.Body className="mb-4">
                  <h5 className="title-header">{t("pages.stores.title")}</h5>
                  <div
                    onClick={() => setCategorydrawer(false)}
                    className="cancel-icon-mobile-tab"
                  >
                    <img src={close_cross} height="20" width="20" alt="close" />
                  </div>
                  <CategoryList
                    className="catelist"
                    onClear={clearCategories}
                    data={props?.categories}
                    onSelect={selectCategoryfromlist}
                    type={props?.storetype}
                    title={t("pages.stores.categories")}
                    listType={"GridView"}
                  />
                  <div className="mt-3 cate-product">
                    <LazyLoadImage alt="" src={storelistCategory} />
                  </div>
                </Card.Body>
              </Card>
            </div>
            {/* <div className={Categorydrawer ? "onclose show" : "onclose"} onClick={() => setCategorydrawer(false)}></div> */}
            <div className={Categorydrawer ? "col-xl-9 show" : "col-xl-9"}>
              <Card className="card px-2">
                <Card.Body className="card-body">
                  <div className="flex just-space">
                    <div className="align-center">
                      <div
                        className="menu-list m-1"
                        onClick={() => setCategorydrawer(!Categorydrawer)}
                      >
                        <LazyLoadImage src={category_icon} alt={""} />
                      </div>
                      {props?.language === "Tr" ? (
                        <label className="title-result ">
                          {paginationvalue?.total} {t("pages.stores.results")}{" "}
                          {paginationvalue?.from} - {paginationvalue?.to}{" "}
                          {t("pages.stores.of")} {t("pages.stores.showing")}
                        </label>
                      ) : (
                        <label className="title-result">
                          {t("pages.stores.showing")} {paginationvalue?.from} –{" "}
                          {paginationvalue?.to} {t("pages.stores.of")}{" "}
                          {paginationvalue?.total} {t("pages.stores.results")}
                        </label>
                      )}
                    </div>
                    <div className="right-align d-flex align-center">
                      <span className="secoundary pe-2">
                        {t("pages.stores.shortby")}:
                      </span>
                      <div className="">
                        <DropdownButton
                          className="sortby-dropdown"
                          variant={"primary"}
                          id="sortby"
                          title={
                            <>
                              <span>
                                {sortType === ""
                                  ? t("pages.add_product.tax_place")
                                  : t(sortType)}
                              </span>
                              <i className="icon_after arrow_down " />
                            </>
                          }
                        >
                          <Dropdown.Item
                            onClick={(e) => sortingList(e, "desc")}
                          >
                            {t("pages.stores.sort_latest")}
                          </Dropdown.Item>
                          <Dropdown.Item onClick={(e) => sortingList(e, "asc")}>
                            {t("pages.stores.Sort by name")}
                          </Dropdown.Item>
                          <Dropdown.Item onClick={(e) => sortingList(e, "most")}>
                            {t("pages.stores.Most Visited")}
                          </Dropdown.Item>
                        </DropdownButton>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
              <div className="col-12 lists storeListInner">
                {/* <div className="category_details"></div> */}
                <div className="row list-row">
                  {nopagination ? (
                    <div className="no_product">
                      <LazyLoadImage alt="" src={no_product} />
                      <h5 className="mt-2">{t("pages.No store found")}</h5>
                    </div>
                  ) : (
                    storelist?.map((item, index) => (
                      <div
                        className="col-3 store-lists"
                        key={index.toString()}
                        onClick={() => openStore(item.id)}
                      >
                        <Card className="card shadow">
                          <Card.Body className="card-body">
                              <div className="card-images">
                                {props?.ImagePreviewLoader({item:item})}
                              {item?.home_delivery === "yes" &&
                                <span className="disk btn home_delivery">
                                  {t('pages.Home Delivery Available')}
                                </span>}
                                <div
                                  className="store-wishlist"
                                  onClick={(e) =>
                                    addorremoveBookmark(
                                      e,
                                      item.id,
                                      item.bookmark,
                                      item.bookmark_id
                                    )
                                  }
                                >
                                  <div className={`mask_icon ${item.bookmark === "no" ? 'heart_unlike' : 'heart_like'}`}/>
                                </div>
                              </div>
                            <div className="p-2 store-div-details">
                              <div className="card-title">{item.title}</div>
                              {/* <span
                                className="delivery"
                                style={{
                                  display:
                                    item.delivery_max_time === null
                                      ? "none"
                                      : "",
                                }}
                              >
                                {t("pages.stores.delivery_time")}:{" "}
                                <span>{item.delivery_max_time}</span>
                              </span> */}
                               <span
                                className="delivery"
                              >
                                {t("pages.Distance")}:{" "}
                                <span>{item.distance}km</span>
                              </span>
                              <label className="location">
                                {/* <img src={map_marker} alt="" height="17" width="17" ></img> */}
                                <i className="mask_icon map_icon num-color" />
                                <span>{item.address}</span>
                              </label>
                              {item?.home_delivery === "yes" &&
                                <span className="mobile btn home_delivery">
                                  {t('pages.Home Delivery Available')}
                                </span>}
                            </div>
                          </Card.Body>
                        </Card>
                      </div>
                    ))
                 )}
                </div>
              </div>
              {nopagination === false && paginationvalue?.total > 20 && (
                <div className="text-end mt-4">
                  <PaginationPage
                    changeCurrentpage={changeCurrentpage}
                    nopagination={nopagination}
                    links={links}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </aside>
    </>
  );
}

const mapStateToProps = (state) => ({
  access_token: state?.login.access_token,
  categories: state?.home?.categories,
  currentLocation: state?.home?.currentLocation,
  storetype: state?.home?.storetype,
  language: state?.languageState?.language,
});

export default connect(mapStateToProps, {
  currentLocationInfo,
  storeCategories,
  fetchHeaderContent,
  ImagePreviewLoader
})(StorelistPage);
